import gsap from "gsap";
import { Barker } from "../components/barker.js";

console.log("awooooo!");

const tl = gsap.timeline();

tl.to(".account-button", { backgroundColor: "black", duration: 1 });
tl.to(".account-button", { backgroundColor: "white", duration: 1 });

customElements.define("barker-alert", Barker);
